import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spinner } from 'react-bootstrap';
import { MdFilterList } from 'react-icons/md';
import { URL } from '../../variables';
import './OrganizationFilter.css';

export default function OrganizationFilter({ user, token, value = '', onChange }) {
    const [show, setShow] = useState(false);
    const [draft, setDraft] = useState(value);
    const [organizations, setOrganizations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (!show || user?.role !== 'region_admin') return;
        let active = true;
        setLoading(true);
        setError('');
        fetch(`${URL}api/faculdade/get_organizadoras_filtro`, {
            headers: { Accept: 'application/json', Authorization: `Bearer ${token}` },
        }).then(async response => {
            const data = await response.json();
            if (!response.ok || !Array.isArray(data.organizadoras)) throw new Error();
            if (active) setOrganizations(data.organizadoras);
        }).catch(() => {
            if (active) setError('Não foi possível carregar as organizações. Feche e abra o filtro para tentar novamente.');
        }).finally(() => {
            if (active) setLoading(false);
        });
        return () => { active = false; };
    }, [show, token, user?.role]);

    if (user?.role !== 'region_admin') return null;
    const selected = organizations.find(item => item.id === value);
    return <>
        <Button variant={value ? 'primary' : 'outline-primary'} className="organization-filter-button hidethis"
            aria-label={value ? `Filtrar por organização: ${selected?.name || 'filtro ativo'}` : 'Filtrar por organização'}
            title={value ? `Organização: ${selected?.name || 'filtro ativo'}` : 'Filtrar por organização'}
            onClick={() => { setDraft(value); setShow(true); }}>
            <MdFilterList size={22} />
            {value && <span className="organization-filter-dot" aria-hidden="true" />}
        </Button>
        <Modal className="hidethis" show={show} onHide={() => setShow(false)} centered>
            <Modal.Header closeButton><Modal.Title>Filtrar por organização</Modal.Title></Modal.Header>
            <Modal.Body>
                <p className="text-muted">Escolha a organização cujos registros deseja visualizar.</p>
                {error && <div className="alert alert-danger" role="alert">{error}</div>}
                <Form.Group controlId="organization-filter-selection">
                    <Form.Label>Organização</Form.Label>
                    <Form.Select value={draft} disabled={loading || !!error} onChange={event => setDraft(event.target.value)}>
                        <option value="">Todas as organizações</option>
                        {organizations.map(item => <option key={item.id} value={item.id}>{item.name}</option>)}
                    </Form.Select>
                </Form.Group>
                {loading && <div className="mt-3 d-flex align-items-center gap-2"><Spinner animation="border" size="sm" /> Carregando organizações...</div>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="outline-secondary" onClick={() => { onChange(''); setShow(false); }}>Limpar filtro</Button>
                <Button variant="primary" disabled={loading || !!error} onClick={() => { onChange(draft); setShow(false); }}>Aplicar filtro</Button>
            </Modal.Footer>
        </Modal>
    </>;
}
